export default __webpack_public_path__ + "493afe7ae8ecfe26880062706f9bc876.woff2";